import React, { useEffect } from 'react'
import BaseModal from './BaseModal'
import { Container, Modal, Row } from 'react-bootstrap'
import imgBuddha from 'assets/images/eventBoatRacing/imgBuddha.png'
import imgLetsGo from 'assets/images/eventBoatRacing/imgLetsGo.png'
import imgBoatSteps from 'assets/images/eventBoatRacing/imgBoatSteps.png'
import { useTranslation } from 'react-i18next'

function BuffPopupModal({ show, onHide, step, type, ...otherProps }) {
	const { t } = useTranslation()

	useEffect(() => {
		let timeoutId
		if (show) {
			timeoutId = setTimeout(() => {
				onHide()
			}, 3000)
		}

		return () => {
			clearTimeout(timeoutId)
		}
	}, [show])

	return (
		<BaseModal show={show} onHide={onHide} hideDecor={true} {...otherProps}>
			<Modal.Body className="py-0">
				{type === 'blessing' ? (
					<>
						<div className="d-flex justify-content-center">
							<img src={imgBuddha} alt="Buddha" />
						</div>
						<div className="popup-content">
							<p className="mt-3 text-center popup-content-text text-large blessing gold fst-italic">
								{t('event.boat_racing.popup.reward.blessing')}
							</p>
						</div>
					</>
				) : type === 'step' ? (
					<>
						<div className="d-flex justify-content-center align-items-center">
							<img srcSet={`${imgBoatSteps} 2x`} alt="Boat" height={190} />
							<img srcSet={`${imgLetsGo} 2x`} alt="Let's go" />
						</div>

						<div>
							<p
								className="text-center popup-content-text text-large red mt-2"
								style={{ fontFamily: '"roboto", sans-serif' }}
							>
								{step === 1
									? t('event.boat_racing.popup.reward.steps')
										.replace('_STEP_', step)
										.replace('steps', 'step')
									: t('event.boat_racing.popup.reward.steps').replace(
										'_STEP_',
										step,
									)}
							</p>
						</div>
					</>
				) : null}
			</Modal.Body>
		</BaseModal>
	)
}

export default BuffPopupModal
